export class Funcionario {
  idFuncionario: number | null = 0
  idCentroCusto: number | null = 0
  nome: string = ""
  datanascimento?: string | null
  dataadmissao?: string | null
  datademissao?: string | null
  dataafastamento?: string | null
  idCargo: number | null = 0
  setor?: string | null
  descricaoCargo?: string | null
  filial?: string | null
  status?: number
  sexo: string | null = null
  regimeContratacao: string | null = null
  idMotivoDemissao: number | null = null
  idMotivoAfastamento: number | null = null
}

export interface FuncionarioResume {
  idFuncionario: number
  nome: string
}
